import settingsReader from '../../../store/readHelpers/SettingsReader';

const annotationListSelector = {
    selectNotes(annotationList, currentlyShownQuestionId) {
        const notes = annotationList.filter(item => !item.isHighlight);
        if (settingsReader.isOneWayNavigationEnabled()) {
            return notes.filter((note) => {
                return note.data.contentId === currentlyShownQuestionId;
            });
        }

        return notes;
    },

    selectProps(state) {
        const {
            currentlyShown: { questionId },
            studentHighlights: { annotationList, focusedAnnotation },
        } = state;

        return {
            notes: this.selectNotes(annotationList, questionId),
            focusedAnnotation,
        };
    },
};

export default annotationListSelector;
